import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
//import { AdminService } from '../services/admin.service';
import { DataService_batchattendance } from "./shared/data.service";
import { UserService } from "../../../shared/services/user.service";
import * as moment from "moment";

import { ConfirmationService } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { BatchAttendanceModifyRequest } from "./shared/BatchAttendanceModifyRequest";

@Component({
	selector: "caass-admin",
	templateUrl: "./batchattendance.component.html",
	styleUrls: ["./batchattendance.component.css"],
})
export class BatchAttendanceComponent {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dataService: DataService_batchattendance
	) {}

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////

	subscription: any;

	attendanceData = {
		SchoolID: 0,
		AddModifyOption: "New",
		StudentType: "Academy",
		SelectionVal: 0,
		AttendanceType: "OnTime",
		StartDate: new Date(),
		StartTime: new Date(),
		ExcuseID: 0,
	};
	schoolList: any = [];
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	lstSelectionVals: any = [];
	lstAttendanceExcuses: any = [];

	lstStudentsBy = [
		{
			StudentType: "Academy",
		},
		{
			StudentType: "Grade",
		},
		{
			StudentType: "Group",
		},
		{
			StudentType: "Homeroom",
		},
		{
			StudentType: "School",
		},
	];

	ChangeEntryTime: boolean = false;

	//////////////////////////////////////////
	// Load Lists
	//////////////////////////////////////////

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;
				this.attendanceData.SchoolID = this.schoolList[0].SchoolID;

				this.loadSelectionVals();
				this.loadAttendanceExcuses();
			},
			(error) => {}
		);
	}

	private loadSelectionVals() {
		var result = this.dataService.loadSelectionVals(this.attendanceData.SchoolID, this.attendanceData.StudentType);
		result.subscribe(
			(response) => {
				this.lstSelectionVals = response;
				this.attendanceData.SelectionVal = this.lstSelectionVals[0].ID;
			},
			(error) => {}
		);
	}

	private loadAttendanceExcuses() {
		var result = this.dataService.loadAttendanceExcuses(this.attendanceData.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAttendanceExcuses = response;
				this.attendanceData.ExcuseID = this.lstAttendanceExcuses[0].ExcuseID;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.attendanceData.SelectionVal == undefined) {
			this.errorMessage = "Please select a valid group of students";
			return;
		}

		//Check date
		this.attendanceData.StartDate.setHours(0, 0, 0, 0);

		//Date before today
		// var Today = new Date();
		// Today.setHours(0, 0, 0, 0);

		// if (this.attendanceData.StartDate < Today) {
		// 	this.errorMessage = "Cannot edit a date before today";
		// 	return;
		// }

		//Check if date is on the weekend
		if (this.attendanceData.StartDate.getDay() == 0 || this.attendanceData.StartDate.getDay() == 6) {
			//Confirm popup
			this.confirmationService.confirm({
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "The selected day is on the weekend. Are you sure you want to add or modify attendance records for this day?",
				header: "Batch Attendance on Weekend",
				icon: "fa",
				accept: () => {
					this.CreateBatchAttendance();
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.CreateBatchAttendance();
		}
	}

	CreateBatchAttendance() {
		if (this.attendanceData.AddModifyOption == "New") {
			this.AddNewRecord();
		} else {
			this.ModifyRecord();
		}
	}

	AddNewRecord() {
		var TypeChar = "";
		if (this.attendanceData.StudentType == "Academy") {
			TypeChar = "A";
		} else if (this.attendanceData.StudentType == "Grade") {
			TypeChar = "G";
		} else if (this.attendanceData.StudentType == "Group") {
			TypeChar = "R";
		} else if (this.attendanceData.StudentType == "Homeroom") {
			TypeChar = "H";
		} else if (this.attendanceData.StudentType == "School") {
			TypeChar = "S";
		}

		var StatusID = 0;
		if (this.attendanceData.AttendanceType == "OnTime") {
			StatusID = 1;
		} else if (this.attendanceData.AttendanceType == "Tardy") {
			StatusID = 3;
		} else if (this.attendanceData.AttendanceType == "Absent") {
			StatusID = 2;
		}

		var EntryTypeID = 8; //Batch Attendance

		var ExcuseID = this.attendanceData.ExcuseID;
		if (StatusID == 1) {
			ExcuseID = -1;
		}

		var parms: BatchAttendanceModifyRequest = {
			GivenDate: moment(this.attendanceData.StartDate).format("MM/DD/YYYY"),
			UpdateTime: 1,
			GivenTime: moment(this.attendanceData.StartTime).format("HH:mm:00 a"),
			ID: this.attendanceData.SelectionVal,
			TypeChar: TypeChar,
			StatusID: StatusID,
			EntryTypeID: EntryTypeID,
			ExcuseID: ExcuseID,
			SchoolID: this.attendanceData.SchoolID,
			c_personID: this.user.personID,
			c_comment: "",
		};

		var result = this.dataService.AttendanceBatchInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Batch Attendance Entry was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create Batch Attendance Entry",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	ModifyRecord() {
		var TypeChar = "";
		if (this.attendanceData.StudentType == "Academy") {
			TypeChar = "A";
		} else if (this.attendanceData.StudentType == "Grade") {
			TypeChar = "G";
		} else if (this.attendanceData.StudentType == "Group") {
			TypeChar = "R";
		} else if (this.attendanceData.StudentType == "Homeroom") {
			TypeChar = "H";
		} else if (this.attendanceData.StudentType == "School") {
			TypeChar = "S";
		}

		var StatusID = 0;
		if (this.attendanceData.AttendanceType == "OnTime") {
			StatusID = 1;
		} else if (this.attendanceData.AttendanceType == "Tardy") {
			StatusID = 3;
		} else if (this.attendanceData.AttendanceType == "Absent") {
			StatusID = 2;
		}

		var EntryTypeID = 8; //Batch Attendance

		var ExcuseID = this.attendanceData.ExcuseID;
		if (StatusID == 1) {
			ExcuseID = -1;
		}

		var c_comment = "";

		var parms: BatchAttendanceModifyRequest = {
			GivenDate: moment(this.attendanceData.StartDate).format("MM/DD/YYYY"),
			UpdateTime: this.ChangeEntryTime == true ? 1 : 0,
			GivenTime: moment(this.attendanceData.StartTime).format("HH:mm:00 a"),
			ID: this.attendanceData.SelectionVal,
			TypeChar: TypeChar,
			StatusID: StatusID,
			EntryTypeID: EntryTypeID,
			ExcuseID: ExcuseID,
			SchoolID: this.attendanceData.SchoolID,
			c_personID: this.user.personID,
			c_comment: c_comment,
		};

		var result = this.dataService.AttendanceBatchUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Batch Attendance Entry was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the Batch Attendance Entry",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.attendanceData.SchoolID = val;

		this.loadSelectionVals();
		this.loadAttendanceExcuses();
	}

	onStudentTypeChange(val) {
		this.errorMessage = "";

		this.attendanceData.StudentType = val;

		this.loadSelectionVals();
		this.loadAttendanceExcuses();
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////

	ShowEntryTimeOption() {
		return this.attendanceData.AddModifyOption == "Modify";
	}

	ShowEntryTime() {
		return this.attendanceData.AddModifyOption == "New" || this.ChangeEntryTime == true;
	}

	//////////////////////////////////////////
}
